import React from 'react'

const Titles = () => (
  <div>
    <h1 className="title-container__title">React Weather</h1>
    <p className="title-container__subtitle">Find out temperature, Conditions and more...</p>
  </div>
);
export default Titles;
